export default {
  text1:
    'For security reasons we are not allowed to keep you logged in for longer than ',
  text2: ' minutes when being inactive',
  logout: 'Logout',
  refresh: 'Refresh page'
};
